import axiosInstance, { getAPIURL } from "../axiosInstance";
import { useQuery } from "@tanstack/react-query";
import { Memberships, Params } from "../../types/Types";

export function useGetMemberships({
  enabled = true,
}: Params = {}) {
  return useQuery({
    enabled,
    queryKey: ['memberships'],
    queryFn: async () => {
      const url = getAPIURL(`/Membership/All`);
      return axiosInstance<Memberships[]>(url).then((res) => res.data);
    },
  });
}